import Dropdown from '@mui/joy/Dropdown'
import MenuButton from '@mui/joy/MenuButton'
import Menu from '@mui/joy/Menu'
import MenuItem from '@mui/joy/MenuItem'
import { useNavigate } from 'react-router-dom'
import Add from '@mui/icons-material/Add'

export const CreateNewTemplateButton = () => {
    const navigate = useNavigate()
    return (
        <Dropdown>
            <MenuButton variant="soft" color="primary" startDecorator={<Add />}>
                Create New
            </MenuButton>
            <Menu>
                <MenuItem onClick={() => navigate('/merchant/builder/blog')}>
                    Blog template
                </MenuItem>
                <MenuItem onClick={() => navigate('/merchant/builder/quote')}>
                    Text template
                </MenuItem>
                <MenuItem onClick={() => navigate('/merchant/builder/listing')}>
                    Listing template
                </MenuItem>
            </Menu>
        </Dropdown>
    )
}
